import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { ApplicationSteps } from "../../../../models/applications.models";
import { AuthService } from "../../../../../services/auth.service";
import { DomainDefinitionService } from "../../../../../builder/services/domain-definition.service";
import { DomainValue } from '../../../../../models/domain.model';
import { IUploadFile } from '../../../../../common/services/document-management.service';


@Component({
    selector: 'app-stratigraphic-review',
    templateUrl: './stratigraphic-review.component.html',
    styleUrls: ['./stratigraphic-review.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss', '../../../application-section-base/application-section-base.component.scss'],
    standalone: false
})
export class StratigraphicReviewComponent extends ApplicationSectionBaseComponent implements OnInit, OnDestroy {

    readonly step: ApplicationSteps = ApplicationSteps.Review;

    get applicationCompleteDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('completeDate');
        if (ctrl == null) return null;
        return ctrl.value != null ? new Date(ctrl.value) : null;
    }

    set applicationCompleteDate(value: Date) {
        if (this.form == null) return;
        let ctrl = this.form.get('completeDate');
        if (ctrl == null) return;
        ctrl.setValue(value);
    }

    private _isDrill: boolean = true;

    get isDrill(): boolean {
        return this._isDrill;
    }

    @Input() set isDrill(value: boolean) {
        this._isDrill = value;
    }

    subscription: Subscription = new Subscription();

    updatedAPIHelpText: string = "e.g., if the Side Track or Completion numbers need to be updated. <br />API #'s must be provided as 14-digit numbers.";

    //wellClasses: DomainValue[] = [];

    constructor(_auth: AuthService, private domainService: DomainDefinitionService) { super(_auth); }

    ngOnInit() {
        //const obs$: Observable<DomainValue[]> = this.domainService.getValues("CAT").pipe(
        //    tap((data: DomainValue[]) => {
        //        this.wellClasses = data;
        //        this.wellClasses.unshift({
        //            Code: "", Definition: ""
        //        } as DomainValue);
        //    })
        //);
        //let subs$: Subscription = obs$.subscribe(
        //    () => { },
        //    (error) => {
        //        console.error(error);
        //    }
        //);
        //this.subscription.add(subs$);
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    completeDateChanged(model: Date): void {
        this.applicationCompleteDate = model;
    }

    documentTypeLookup(fieldName: string): string {
        let docType: string = "";
        switch (fieldName) {
            case "twentyFortyAcre": {
                docType = "DNR - OG - PRMT-Permit Cond. 20 / 40 Acre";
                break;
            }
            case "annualDisposal": {
                docType = "DNR - OG - PRMT-Permit Cond. Annual Disposal";
                break;
            }
            case "annularDisposal": {
                docType = "DNR - OG - PRMT-Permit Cond. AD-Construction, Operating, Reporting";
                break;
            }
            case "ashtabulaDevonianFluidRotary": {
                docType = "DNR - OG - PRMT-Permit Cond. Ashtabula, Lake-Dev. Shale Fluid Rtry";
                break;
            }
            case "ashtabulaDevonianOriskany": {
                docType = "DNR - OG - PRMT-Permit Cond. Ashtabula, Lake-Dev. Shale & Oriskany";
                break;
            }
            case "enhancedRecovery": {
                docType = "DNR - OG - PRMT-Permit Cond. Class II Enhanced Recov. Inject. Well";
                break;
            }
            case "conductorMineStringComboBasket": {
                docType = "DNR - OG - PRMT-Permit Cond. Conductor - Mine String Combo Basket";
                break;
            }
            case "directionalDrilling": {
                docType = "DNR - OG - PRMT-Permit Cond. Directional Drilling";
                break;
            }
            case "failureToMaintainInsurance": {
                docType = "DNR - OG - PRMT-Permit Cond. Failure to Maintain Ins. Coverage";
                break;
            }
            case "fluidRotaryLakePlainOriskany": {
                docType = "DNR - OG - PRMT-Permit Cond. Fluid Rotary Rigs-Lake Plain Region";
                break;
            }
            case "horizontalDrilling": {
                docType = "DNR - OG - PRMT-Permit Cond. Horizontal Drilling";
                break;
            }
            case "hydrogenSulfide": {
                docType = "DNR - OG - PRMT-Permit Cond. Hydrogen Sulfide";
                break;
            }
            case "ielSuperfund": {
                docType = "DNR - OG - PRMT-Permit Cond. IEL Superfund";
                break;
            }
            case "knoxUnconformity": {
                docType = "DNR - OG - PRMT-Permit Cond. Knox Unconformity";
                break;
            }
            case "lakePlainRegionOriskany": {
                docType = "DNR - OG - PRMT-Permit Cond. Lake Plain Region - Oriskany & Deeper";
                break;
            }
            case "lakePlainRegionUtica": {
                docType = "DNR - OG - PRMT-Permit Cond. Lake Plain Region - Utica and Deeper";
                break;
            }
            case "mineStringBasketVoid": {
                docType = "DNR - OG - PRMT-Permit Cond. Mine String Basket - 450 Feet Void";
                break;
            }
            case "mineStringBasketGreaterThreeHundred": {
                docType = "DNR - OG - PRMT-Permit Cond. Mine String Basket - Void > 300 Feet";
                break;
            }
            case "mineStringBasketLessThanThreeHundred": {
                docType = "DNR - OG - PRMT-Permit Cond. Mine String Basket - Void < 300 Feet";
                break;
            }
            case "municipalWellheadProtection": {
                docType = "DNR - OG - PRMT-Permit Cond Municipal WH Protection Area - Clinton";
                break;
            }
            case "municipalWellheadProtectionQueenston": {
                docType = "DNR - OG - PRMT-Permit Cond Municipal WH Protect Area - Queen-Knox";
                break;
            }
            case "noPerforationZone": {
                docType = "DNR - OG - PRMT-Permit Cond. No Perforation Zone";
                break;
            }
            case "noiseMitigation": {
                docType = "DNR - OG - PRMT-Permit Cond. Noise Mitigation";
                break;
            }
            case "oldWellUnknownStatus": {
                docType = "DNR - OG - PRMT-Permit Cond. Old Well Unknown Status W/Spacing";
                break;
            }
            case "otherConditions": {
                docType = "DNR - OG - PRMT-Permit Cond. Other";
                break;
            }
            case "prePermittingShaleSite": {
                docType = "DNR - OG - PRMT-Permit Cond. Pre-Permitting - Shale Site";
                break;
            }
            case "prePermittingUrbanSite": {
                docType = "DNR - OG - PRMT-Permit Cond. Pre-Permitting - Urban Site";
                break;
            }
            case "removalOfFluidHorizontalShale": {
                docType = "DNR - OG - PRMT-Permit Cond. Removal of Fluid";
                break;
            }
            case "seismicActivity": {
                docType = "DNR - OG - PRMT-Permit Cond. Seismic Activity";
                break;
            }
            case "shallowGas": {
                docType = "DNR - OG - PRMT-Permit Cond. Shallow Gas";
                break;
            }
            case "ssm1": {
                docType = "DNR - OG - PRMT-Permit Cond. SSM1";
                break;
            }
            case "ssm4": {
                docType = "DNR - OG - PRMT-Permit Cond. SSM4";
                break;
            }
            case "swiw": {
                docType = "DNR - OG - PRMT-Permit Cond. SWIW";
                break;
            }
            case "surfaceCasingMineStringCombo": {
                docType = "DNR - OG - PRMT-Permit Cond. Surface Casing - Mine String Combo";
                break;
            }
            case "surfaceCasingMineStringComboBasket": {
                docType = "DNR - OG - PRMT-Permit Cond. Surface Casing-Mine String Combo Bskt";
                break;
            }
            case "thinGlacialTillQueenston": {
                docType = "DNR - OG - PRMT-Permit Cond. Thin Glacial Till - Below Queenston";
                break;
            }
            case "thinGlacialTillClinton": {
                docType = "DNR - OG - PRMT-Permit Cond. THin Glacial Till - To Clinton";
                break;
            }
            case "trempealeau": {
                docType = "DNR - OG - PRMT-Permit Cond. Trempealeau In Morrow County";
                break;
            }
            case "wellInAOR": {
                docType = "DNR - OG - PRMT-Permit Cond. Well in AOR";
                break;
            }
        }
        return docType;
    }

    fileAdded(evt: IUploadFile, field: string): void {
        let ctrl = this.findMatchingControl(`specialConditions|${field}`);
        if (ctrl != null) {
            const files: IUploadFile[] = <IUploadFile[]>ctrl.value;
            const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
            if (isNew) {
                evt.documentType = this.documentTypeLookup(field);
                files.push(evt);
                ctrl.setValue(files);
            }
        }
    }

    fileRemoved(evt: IUploadFile, field: string): void {
        let ctrl = this.findMatchingControl(`specialConditions|${field}`);
        if (ctrl != null) {
            const files: IUploadFile[] = <IUploadFile[]>ctrl.value;
            const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
            if (fileIndex !== -1) {
                files.splice(fileIndex, 1);
                ctrl.setValue(files);
            }
        }
    }


    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }

}
